import { useState } from 'react'
import ClienteLayout from '../../components/ClienteLayout'

const WA_NUMERO = '59898610001'
const WA_TEL_DISPLAY = '+598 98 610 001'
const EMAIL = 'hola@limpack.uy'

const CATEGORIAS = [
  { id: 'entrega',    icon: '📦', label: 'Mi entrega',     sub: 'Día · horario · zona' },
  { id: 'pagos',      icon: '💳', label: 'Pagos y facturas', sub: 'MP · transferencia · facturas' },
  { id: 'suscripcion',icon: '🔄', label: 'Mi suscripción', sub: 'Pausar · cambiar · cancelar' },
  { id: 'productos',  icon: '🛒', label: 'Productos',       sub: 'Marcas · presentación · stock' },
]

const FAQ = [
  { cat: 'entrega',     q: '¿Puedo cambiar el día de entrega?', a: 'Sí. Desde Mi Plan podés modificar el día de la próxima entrega antes del corte (martes 23:59hs).' },
  { cat: 'suscripcion', q: '¿Cómo pauso mi suscripción durante 1 mes?', a: 'En Mi Plan tocá "Pausar 1 mes". No te cobramos ese mes y reanudamos automáticamente al siguiente.' },
  { cat: 'entrega',     q: '¿Qué pasa si no estoy cuando llega la entrega?', a: 'Si tenés portero, lo dejamos con él. Si no, te avisamos por WhatsApp para reprogramar (sin recargo en la primera).' },
  { cat: 'productos',   q: '¿Cómo agrego productos extra a mi próxima entrega?', a: 'Andá a la Tienda y comprá productos sueltos. Si tu próxima entrega aún no se cerró, los sumamos sin cobrar envío.' },
  { cat: 'pagos',       q: '¿Cuándo se cobra la suscripción?', a: 'El día que elegís al suscribirte (por defecto el 28 de cada mes). Lo podés cambiar desde Mi Plan.' },
  { cat: 'pagos',       q: '¿Qué medios de pago aceptan?', a: 'Mercado Pago (tarjeta de crédito/débito, Abitab, RedPagos) y transferencia bancaria.' },
  { cat: 'suscripcion', q: '¿Tengo permanencia mínima?', a: 'No. Cancelás cuando quieras desde Mi Plan, sin costos ni letra chica.' },
]

function abrirWhatsApp(mensaje = '') {
  const texto = mensaje || 'Hola Limpack, necesito ayuda con mi cuenta.'
  window.open(`https://wa.me/${WA_NUMERO}?text=${encodeURIComponent(texto)}`, '_blank')
}

export default function Soporte() {
  const [catActiva, setCatActiva] = useState(null)
  const faqFiltrado = catActiva ? FAQ.filter(f => f.cat === catActiva) : FAQ
  const cat = (id) => CATEGORIAS.find(c => c.id === id)

  return (
    <ClienteLayout title="Soporte">
      <div className="sp-wrap">
        <div className="sp-headline">
          <h1>¿En qué te ayudamos?</h1>
          <p>Buscá en preguntas frecuentes o escribinos directo por WhatsApp.</p>
        </div>

        <div className="sp-grid">
          {/* Hero WhatsApp */}
          <div className="sp-hero">
            <div className="sp-hero-icon">💬</div>
            <h2 className="sp-hero-h">Hablá con un humano</h2>
            <p className="sp-hero-sub">Respondemos por WhatsApp en menos de 30 minutos durante horario comercial. Más rápido que cualquier otra vía.</p>
            <button className="sp-hero-btn" onClick={() => abrirWhatsApp()}>Abrir WhatsApp →</button>
          </div>

          {/* Datos contacto */}
          <div className="sp-info">
            <h3 className="sp-info-h">📞 Datos de contacto</h3>
            <div className="sp-info-row"><b>Horario</b><span>Lun–Vie 9–18hs · Sáb 10–14hs</span></div>
            <div className="sp-info-row"><b>WhatsApp</b><a href={`https://wa.me/${WA_NUMERO}`} target="_blank" rel="noreferrer">{WA_TEL_DISPLAY}</a></div>
            <div className="sp-info-row"><b>Email</b><a href={`mailto:${EMAIL}`}>{EMAIL}</a></div>
            <div className="sp-info-row"><b>Tiempo respuesta</b><span style={{ color: '#16a34a', fontWeight: 700 }}>~25 min · WhatsApp</span></div>
          </div>
        </div>

        <h2 className="sp-section">Categorías de ayuda</h2>
        <div className="sp-cats">
          {CATEGORIAS.map(c => (
            <button
              className={`sp-cat ${catActiva === c.id ? 'active' : ''}`}
              key={c.id}
              onClick={() => setCatActiva(catActiva === c.id ? null : c.id)}
            >
              <div className="sp-cat-icon">{c.icon}</div>
              <div className="sp-cat-label">{c.label}</div>
              <div className="sp-cat-sub">{FAQ.filter(f => f.cat === c.id).length} pregunta{FAQ.filter(f => f.cat === c.id).length === 1 ? '' : 's'} · {c.sub}</div>
            </button>
          ))}
        </div>

        <h2 className="sp-section">{catActiva ? `Preguntas: ${cat(catActiva)?.label}` : 'Preguntas más consultadas'}</h2>
        <div className="sp-faq">
          {faqFiltrado.map((f, i) => (
            <details className="sp-faq-item" key={i}>
              <summary>
                <span className="sp-faq-q">{f.q}</span>
                <span className="sp-faq-tag">{cat(f.cat)?.label}</span>
              </summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>

        <div className="sp-no-encuentro">
          <span>¿No encontraste lo que buscabas?</span>
          <button className="sp-action" onClick={() => abrirWhatsApp('Hola Limpack, necesito ayuda con algo que no encuentro en el FAQ.')}>
            💬 Hablar con soporte
          </button>
        </div>
      </div>

      <style>{`
        .sp-wrap { max-width: 1320px; margin: 0 auto; padding: 16px 16px 32px }
        .sp-headline h1 { font-size: 26px; font-weight: 900; color: var(--cl-navy); letter-spacing: -.02em }
        .sp-headline p { font-size: 14px; color: var(--cl-muted); margin-top: 4px; line-height: 1.5 }

        .sp-grid { display: grid; grid-template-columns: 1fr; gap: 14px; margin-top: 18px }
        .sp-hero {
          background: linear-gradient(135deg, #25d366, #128c7e); color: #fff;
          border-radius: 18px; padding: 24px;
          display: flex; flex-direction: column; gap: 8px;
        }
        .sp-hero-icon { font-size: 38px }
        .sp-hero-h { font-size: 20px; font-weight: 900; letter-spacing: -.02em }
        .sp-hero-sub { font-size: 13px; opacity: .92; line-height: 1.5 }
        .sp-hero-btn {
          margin-top: 10px; align-self: flex-start;
          background: #fff; color: #128c7e; border: 0;
          padding: 12px 22px; border-radius: 999px;
          font-weight: 800; font-size: 14px; cursor: pointer; font-family: inherit;
        }
        .sp-hero-btn:hover { transform: translateY(-1px) }

        .sp-info {
          background: linear-gradient(135deg, #ecfeff, #cffafe);
          border: 1px solid #67e8f9; border-radius: 16px; padding: 22px;
        }
        .sp-info-h { font-size: 14px; font-weight: 800; color: #155e75; margin-bottom: 10px }
        .sp-info-row {
          display: flex; gap: 10px; padding: 9px 0;
          border-bottom: 1px solid rgba(103,232,249,.4);
          font-size: 12.5px; color: #0e7490; align-items: center;
        }
        .sp-info-row:last-child { border-bottom: 0 }
        .sp-info-row b { color: #155e75; font-weight: 800; min-width: 110px; flex-shrink: 0 }
        .sp-info-row a { color: #0e7490; font-weight: 700; text-decoration: none }
        .sp-info-row a:hover { text-decoration: underline }
        .sp-info-row span { text-align: right; flex: 1 }

        .sp-section { font-size: 16px; font-weight: 900; color: var(--cl-navy); margin: 28px 0 14px; letter-spacing: -.01em }

        .sp-cats { display: grid; grid-template-columns: 1fr 1fr; gap: 10px }
        .sp-cat {
          background: var(--cl-card); border: 1.5px solid var(--cl-line);
          padding: 16px; border-radius: 14px; cursor: pointer; font-family: inherit;
          display: flex; flex-direction: column; gap: 6px; text-align: left;
          transition: border-color .15s, transform .15s;
        }
        .sp-cat:hover { transform: translateY(-2px); border-color: var(--cl-teal) }
        .sp-cat.active { border-color: var(--cl-teal); background: var(--cl-teal-soft, #e6fafc) }
        .sp-cat-icon { font-size: 24px }
        .sp-cat-label { font-size: 13px; font-weight: 800; color: var(--cl-navy) }
        .sp-cat-sub { font-size: 11px; color: var(--cl-muted); line-height: 1.4 }

        .sp-faq { display: flex; flex-direction: column; gap: 10px }
        .sp-faq-item { background: var(--cl-card); border: 1px solid var(--cl-line); border-radius: 12px; padding: 0 18px }
        .sp-faq-item summary { padding: 14px 0; cursor: pointer; list-style: none; display: flex; align-items: center; gap: 10px }
        .sp-faq-item summary::-webkit-details-marker { display: none }
        .sp-faq-q { flex: 1; font-size: 13.5px; font-weight: 700; color: var(--cl-navy) }
        .sp-faq-tag { font-size: 10px; font-weight: 800; padding: 3px 8px; border-radius: 999px; background: var(--cl-line2); color: var(--cl-muted); text-transform: uppercase; letter-spacing: .04em; flex-shrink: 0 }
        .sp-faq-item[open] summary { border-bottom: 1px solid var(--cl-line2); padding-bottom: 14px }
        .sp-faq-item p { font-size: 13px; color: var(--cl-muted); line-height: 1.55; padding: 14px 0 16px }

        .sp-no-encuentro {
          margin-top: 24px; padding: 18px 20px;
          background: var(--cl-card); border: 1px dashed var(--cl-line);
          border-radius: 12px; display: flex; align-items: center; justify-content: space-between; gap: 14px; flex-wrap: wrap;
          font-size: 13px; color: var(--cl-muted);
        }
        .sp-action {
          background: linear-gradient(135deg, #25d366, #128c7e); color: #fff; border: 0;
          padding: 10px 18px; border-radius: 999px; font-size: 13px; font-weight: 800;
          cursor: pointer; font-family: inherit;
        }

        @media (min-width: 900px) {
          .sp-wrap { padding: 36px 44px }
          .sp-headline h1 { font-size: 32px }
          .sp-grid { grid-template-columns: 1.4fr 1fr; gap: 20px; margin-top: 24px }
          .sp-hero { padding: 32px }
          .sp-hero-h { font-size: 24px }
          .sp-hero-sub { font-size: 14px }
          .sp-section { font-size: 18px; margin: 32px 0 16px }
          .sp-cats { grid-template-columns: repeat(4, 1fr); gap: 14px }
          .sp-cat { padding: 20px }
          .sp-faq-q { font-size: 14px }
          .sp-faq-item p { font-size: 14px }
        }
      `}</style>
    </ClienteLayout>
  )
}
